module.exports = __webpack_public_path__ + "img/disclaimers.a5011860.png";